// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { getAuth, inMemoryPersistence, setPersistence } from "firebase/auth";
import {
  initializeFirestore,
  memoryLocalCache,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration (production).
// Omit REACT_APP_MEASUREMENT_ID for a no-analytics launch; Firebase Analytics is not initialized in this app.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  ...(process.env.REACT_APP_MEASUREMENT_ID
    ? { measurementId: process.env.REACT_APP_MEASUREMENT_ID }
    : {}),
};

const hasRequiredConfig = firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.authDomain;
if (!hasRequiredConfig && process.env.NODE_ENV === 'development') {
  console.warn(
    'Firebase: Missing config (apiKey, projectId, or authDomain). Check .env has REACT_APP_API_KEY, REACT_APP_PROJECT_ID, REACT_APP_AUTH_DOMAIN and restart the dev server (npm start).'
  );
}

// Initialize Firebase (production)
const app = initializeApp(firebaseConfig);

/** App Check — set REACT_APP_APP_CHECK_SITE_KEY (reCAPTCHA Enterprise) in env; enforce server-side with APP_CHECK_ENFORCE=true */
if (
  typeof window !== "undefined" &&
  process.env.REACT_APP_APP_CHECK_SITE_KEY?.trim()
) {
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(
      process.env.REACT_APP_APP_CHECK_SITE_KEY.trim()
    ),
    isTokenAutoRefreshEnabled: true,
  });
}

const auth = getAuth(app);
if (
  typeof window !== "undefined" &&
  window.location.pathname.startsWith("/shopify")
) {
  void setPersistence(auth, inMemoryPersistence);
}
/**
 * IndexedDB persistence can surface intermittent permission-denied / sync errors on hard refresh in dev
 * (multi-tab coordinator + auth token timing). Localhost uses memory cache only; production keeps persistence.
 */
const useMemoryFirestoreCache =
  process.env.NODE_ENV === "development" &&
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
const db = initializeFirestore(app, {
  localCache: useMemoryFirestoreCache
    ? memoryLocalCache()
    : persistentLocalCache({
        tabManager: persistentMultipleTabManager(),
      }),
});
const functions = getFunctions(app, "europe-west1");
const storage = getStorage(app);

export { auth, db, functions, storage };